// extracted by mini-css-extract-plugin
module.exports = {"year-underlay":"YearUnderlay_year-underlay__ffAVY","year":"YearUnderlay_year__2KSe4"};